import ScrollToTop from './scroll-to-top.class';

customElements.define('scroll-to-top', ScrollToTop);
